/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeLocationCounties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Location County Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 10:08:57 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const LOCATIONCOUNTY_LIST_CONTAINER_LOADED = 'LOCATIONCOUNTY_LIST_CONTAINER_LOADED';
export const LOCATIONCOUNTY_LIST_CONTAINER_UNLOADED = 'LOCATIONCOUNTY_LIST_CONTAINER_UNLOADED';
export const LOCATIONCOUNTY_LIST_TABLE_LOADED = 'LOCATIONCOUNTY_LIST_TABLE_LOADED';
export const LOCATIONCOUNTY_LIST_TABLE_UNLOADED = 'LOCATIONCOUNTY_LIST_TABLE_UNLOADED';

export const LOCATIONCOUNTY_LIST_CHANGE_GROUP = 'LOCATIONCOUNTY_LIST_CHANGE_GROUP';
export const LOCATIONCOUNTY_SELECT_ROW = 'LOCATIONCOUNTY_SELECT_ROW';

export const LOCATIONCOUNTY_ADD = 'LOCATIONCOUNTY_ADD';
export const LOCATIONCOUNTY_EDIT = 'LOCATIONCOUNTY_EDIT';
export const LOCATIONCOUNTY_DELETE = 'LOCATIONCOUNTY_DELETE';
export const LOCATIONCOUNTY_OPEN_WARNING = 'LOCATIONCOUNTY_OPEN_WARNING';
export const LOCATIONCOUNTY_CLOSE_WARNING = 'LOCATIONCOUNTY_CLOSE_WARNING';
export const LOCATIONCOUNTY_DELETE_DISABLE = 'LOCATIONCOUNTY_DELETE_DISABLE';
export const LOCATIONCOUNTY_VIEW_CHILD_ITEMS = 'LOCATIONCOUNTY_VIEW_CHILD_ITEMS';

export const LOCATIONCOUNTY_EDIT_CONTAINER_LOADED = 'LOCATIONCOUNTY_EDIT_CONTAINER_LOADED';
export const LOCATIONCOUNTY_EDIT_CONTAINER_UNLOADED = 'LOCATIONCOUNTY_EDIT_CONTAINER_UNLOADED';
export const LOCATIONCOUNTY_EDIT_FORM_LOADED = 'LOCATIONCOUNTY_EDIT_FORM_LOADED';
export const LOCATIONCOUNTY_EDIT_FORM_UNLOADED = 'LOCATIONCOUNTY_EDIT_FORM_UNLOADED';

export const LOCATIONCOUNTY_SET_GROUP_SELECT = 'LOCATIONCOUNTY_SET_GROUP_SELECT';
export const LOCATIONCOUNTY_EDIT_DATA_LOAD = 'LOCATIONCOUNTY_EDIT_DATA_LOAD';

export const LOCATIONCOUNTY_EDIT_CONTAINER_SUBMIT = 'LOCATIONCOUNTY_EDIT_CONTAINER_SUBMIT';
export const LOCATIONCOUNTY_EDIT_CONTAINER_CANCEL = 'LOCATIONCOUNTY_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeLocationCounties.js